import { formatDate, READABLE_DATETIME_FORMAT } from './formatDate';

export const formatGridDate = (date: Date | string | undefined) =>
  date ? formatDate(date, READABLE_DATETIME_FORMAT) : '--';

type OptionsList = { value: any; label: string }[];

export const findGridOptionsLabel = (value: any, optionsList: OptionsList) =>
  optionsList.find((o) => o.value === value)?.label ?? '--';
